import initializeComponent from 'Shared/react-initialize';
import { HelpOutPage } from './HelpOutPage';

initializeComponent('HelpOut', HelpOutPage);
